<template>
  <div v-if="avatarWithLink" class="avatar-wrapper" data-cy="navbar-avatar">
    <div class="container">
      <div class="columns is-align-items-center">
        <div class="column is-narrow">
          <el-avatar> {{ getInitials }} </el-avatar>
        </div>
        <div class="column">
          <div class="avatar-wrapper--name">
            <span class="has-text-weight-bold">{{ getFullName }} </span>
            <span class="has-text-grey"> - {{ getRoleName }}</span>
          </div>
          <div class="has-text-grey-light">{{ getEmail }}</div>
          <slot></slot>
        </div>
      </div>
    </div>
  </div>

  <div v-else>
    <el-avatar> {{ getInitials }} </el-avatar>
    <span> {{ getFullName }} </span>
    <!--
    <el-icon class="el-icon&#45;&#45;right">
      <arrow-down />
    </el-icon>
-->
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
// import { ArrowDown } from "@element-plus/icons-vue";

// modules
import UserModule from "@/store/modules/user";

// interfaces
import { IUser, IUserGroups } from "@/interfaces/responses/user";

export default defineComponent({
  name: "NavbarAvatar",
  components: {
    // ArrowDown,
  },
  props: {
    avatarWithLink: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    /* User data */
    const user = computed<IUser>(() => UserModule.getUser || ({} as IUser));

    const getInitials = computed<string>(() => {
      const firstNameChar = user.value.firstName.charAt(0);
      const lastNameChar = user.value.lastName.charAt(0);

      return `${firstNameChar.toUpperCase()}${lastNameChar.toUpperCase()}`;
    });

    const getFullName = computed<string>(() => {
      return ` ${user.value.fullname}`;
    });

    const getEmail = computed<string>(() => {
      return user.value.emails[0].emailAddress;
    });

    /* UserGroups data */
    const userGroup = computed<IUserGroups>(
      () => UserModule.getUserSelectedGroupInfo
    );

    const getRoleName = computed<string>(() => {
      return userGroup.value.roleName;
    });

    return {
      getFullName,
      getInitials,
      getEmail,
      getRoleName,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.avatar-wrapper {
  padding: 5px 16px;

  &--name {
    min-width: max-content;
  }
}

.el-avatar {
  font-size: 1.2rem;
  color: $color-text-primary;
  background-color: $color-light-orange;
}
</style>
